import { ITEM_PRODUCT_TYPES } from "@constants/orders/cart";
import { ON_DEMAND_PRODUCT } from "@constants/products/detail";

const emptyArr = [];

export const getBatchPopulatePayloadData = ({
  swagProductsThatRequiredVariantsChange = emptyArr,
  nowSwagProductsThatRequiredVariantsChange = emptyArr,
}) => {
  const swagProductPayloadData = swagProductsThatRequiredVariantsChange.reduce(
    (
      productMapping,
      {
        quantity: productQty,
        vendorByCountry,
        storeId,
        masterVariant,
        productId,
        zoneId,
        price,
        itemType = ON_DEMAND_PRODUCT,
      },
    ) => {
      const { externalId } = masterVariant;

      const quantity = productMapping[externalId] ? 1 : productQty;

      const commonAttribute = {
        product_type: ITEM_PRODUCT_TYPES.product,
        vendor_id: vendorByCountry?.externalId,
        zone_id: zoneId,
        store_id: storeId,
        dietary_preference: "",
        item_type: itemType,
      };

      productMapping[externalId] = {
        product_id: externalId,
        price: +price,
        quantity,
        ...commonAttribute,
      };
      productMapping[productId] = {
        product_id: productId.toString(),
        quantity: 0,
        mark_for_destroy: true,
        ...commonAttribute,
      };

      return productMapping;
    },
    {},
  );
  const nonSwagProductPayloadData = nowSwagProductsThatRequiredVariantsChange.reduce(
    (
      productMapping,
      {
        id,
        price,
        quantity: productQty,
        vendorByCountry,
        storeId,
        zoneId,
        pcbId,
        itemType = ON_DEMAND_PRODUCT,
      },
    ) => {
      const commonAttribute = {
        product_id: pcbId,
        storePrice: +price,
        product_type: ITEM_PRODUCT_TYPES.collection,
        vendor_id: vendorByCountry?.externalId,
        zone_id: zoneId,
        store_id: storeId,
        item_type: itemType,
      };

      productMapping[id] = {
        order_product_set_id: id,
        quantity: 0,
        mark_for_destroy: true,
        ...commonAttribute,
      };
      productMapping[pcbId] = {
        quantity: productQty,
        dietary_preference: "",
        dietary_restrictions: {},
        restrictions: "",
        isRestrictionsSelected: false,
        ...commonAttribute,
      };

      return productMapping;
    },
    {},
  );

  return {
    line_items_attributes: Object.values(swagProductPayloadData),
    product_sets_attributes: Object.values(nonSwagProductPayloadData),
  };
};
